import { render, staticRenderFns } from "./DropdownDeleteOptionRenderer.vue?vue&type=template&id=99741694"
import script from "./DropdownDeleteOptionRenderer.vue?vue&type=script&lang=js"
export * from "./DropdownDeleteOptionRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports